import React, { useState, useEffect, useRef } from "react";
import { getCookie } from "../../utils/cookies";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { PencilSquare } from "react-bootstrap-icons";
import AlertDialog from "../../ui/alerts/AlertDialog";

export default function UpdateServiceType({ fetchData, id, item }) {
  // Form Modal state
  const [showUpdate, setShowUpdate] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);

  // Show and Hide Form Modal
  const handleClose = () => setShowUpdate(false);
  const handleShow = () => setShowUpdate(true);

  const [serviceType, setServiceType] = useState({
    name: "",
    desc: "",
  });

  const handleChange = (event) => {
    setServiceType({ ...serviceType, [event.target.name]: event.target.value });
  };

  const inputRef = useRef(null);

  const handleSubmit = (event) => {
    event.prevetDefault();
    setServiceType({ name: "", desc: "" });
  };

  const handleEnable = () => {
    setIsEnabled(true);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  // Success Dialog State
  const [showSuccess, setShowSuccess] = useState(false);

  // Error Dialog State
  const [showError, setShowError] = useState(false);

  // UPDATE
  const updateServiceType = async (id: number) => {
    try {
      const JWT = await getCookie("ea1-auth");
      const { data } = await axios(
        `https://ea1-dev.azurewebsites.net/api/serviceType/${id}`,
        {
          method: "PATCH",
          data: {
            name: serviceType.name,
            description: serviceType.desc,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: JWT,
          },
        }
      );
      setData(data);
      setIsLoading(false);

      // Hides Modal on submission
      setShowUpdate(false);

      // Success Alert Popup
      setShowSuccess(true);

      setIsEnabled(false);
    } catch (e) {
      setIsLoading(false);

      // Hides Modal on submission
      setShowUpdate(false);

      // Error Alert Popup
      setShowError(true);
    }
  };

  // Table state update on submit
  useEffect(() => {
    fetchData(data);
  }, []);

  const updateServiceModal = (
    <Modal show={showUpdate} backdrop='static' onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Update Service Type</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className='mb-3' controlId='exampleForm.ControlInput1'>
            <Form.Label>Service Type Name</Form.Label>
            <Form.Control
              ref={inputRef}
              type='text'
              name='name'
              placeholder='Service Type Name'
              autoFocus
              onChange={handleChange}
              defaultValue={item.name}
              onKeyDown={handleEnable}
            />
          </Form.Group>
          <Form.Group className='mb-3' controlId='exampleForm.ControlTextarea1'>
            <Form.Label>Description</Form.Label>
            <Form.Control
              ref={inputRef}
              as='textarea'
              name='desc'
              rows={3}
              placeholder='Please describe what this service type is'
              onChange={handleChange}
              defaultValue={item.description}
              onKeyDown={handleEnable}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outline-dark' onClick={handleClose}>
          Cancel
        </Button>
        <Button
          type='submit'
          variant='dark'
          onClick={() => updateServiceType(id)}
          disabled={!isEnabled}
        >
          Update
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const successAlert = (
    <Modal
      show={showSuccess}
      onHide={() => {
        setShowSuccess(false);
        handleClose();
      }}
      backdrop='static'
    >
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#00E676" }}
      ></Modal.Header>
      <AlertDialog
        title={"Success!"}
        message={"Service Type was successfully updated."}
      />
    </Modal>
  );

  const errorAlert = (
    <Modal
      show={showError}
      onHide={() => {
        setShowError(false);
        handleClose();
      }}
      backdrop='static'
    >
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#FF1744" }}
      ></Modal.Header>
      <AlertDialog
        title={"Error!"}
        message={"There was an error updating the Service Type."}
      />
    </Modal>
  );

  return (
    <>
      <PencilSquare onClick={handleShow} />
      {updateServiceModal}
      {successAlert}
      {errorAlert}
    </>
  );
}
